import { type FC, PropsWithChildren } from 'react';

import { Props } from '../DropDown/DropDown';
import { Wrapper } from './styled';

const FilterDropDown: PropsWithChildren<FC<Props>> = ({ children, ...rest }): JSX.Element => (
  <Wrapper {...rest}>{children}</Wrapper>
);

export default FilterDropDown;
